//==============================================
// Block: Approach
//==============================================

(function ($) {

var initBlockApproach = function( $block ) {

	let blockInner = $block.find('.block-approach__inner').children();
	
	let blockNavInit = $block.find('.block-approach__nav-item:first-child'),
		blockPanelInit = $block.find('#process'),
		blockNavItem = $block.find('.block-approach__nav-item'),
		blockPanel = $block.find('.block-approach__panel'),
		clickDisable = true;

	let blockInit = gsap.timeline({
		scrollTrigger: {
			trigger: $block,
			start: 'top 80%'
			//markers: true
		}
	});

		// Init Default

		blockNavInit.addClass('block-approach__nav-item-active');

		blockPanelInit.css('opacity', 1);


		blockInit.from(blockInner, {
			duration: 3,
			ease: "power1.out",
			opacity: '0',
			stagger: 0.5
		});



		$(blockNavItem).on('click keypress', function(e){

			e.preventDefault();

			if(clickDisable){

				clickDisable = false;

				let target = $(this).attr('href');

				// Active Class
				blockNavItem.removeClass('block-approach__nav-item-active');
				$(this).addClass('block-approach__nav-item-active');


				// Active Panel
				blockPanel.css('opacity', 0);

				setTimeout(() => {

					$(target).css('opacity', 1);
					clickDisable = true;
					
				}, 1000);

			}


		});

};



// Initialize each block on page load (front end).
$(function(){
	$('.block-approach').each(function(){
		initBlockApproach( $(this) );
	});
});

if( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=block-approach', initBlockApproach);
}

})(jQuery);